// extracted by mini-css-extract-plugin
module.exports = {"root":"CartGroup_root__1seF5","header":"CartGroup_header__2VZAE","title":"CartGroup_title__1qSvx","list":"CartGroup_list__1_dRy","button":"CartGroup_button__1jK4t"};